/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import {
    EImportPersonalDataField,
    EWizardImportPersonalDataSteps,
} from '../../../../pages/WizardImportPersonalData/wizardImportPersonalDataConstant';
import { IWizardImportPersonalDataTranslation } from '../../types/wizards/importPersonalData';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardImportPersonalDataTranslation: IWizardImportPersonalDataTranslation = {
    ...initWizardPropsTranslation,
    [EWizardImportPersonalDataSteps.DocumentSelectionStep]: {
        attachError: {
            codes: {},
        },
        chooseFile: '',
        info: '',
        maxImportSubs: '',
        template: '',
        templateUrl: '',
        title: '',
        warning: '',
    },
    [EWizardImportPersonalDataSteps.ContentValidationStep]: {
        counterLabel: '',
        title: '',
        warning: '',
    },
    [EWizardImportPersonalDataSteps.ConfirmImportStep]: {
        counterLabel: '',
        exportButton: '',
        exportModal: {
            closeButton: '',
            exportButton: '',
            info: '',
            title: '',
        },
        status: {
            conflictTitle: '',
            error: '',
            success: '',
        },
        warning: {
            default: '',
            personalDataConfirmation: '',
            picInformation: '',
        },
    },
    table: {
        [EImportPersonalDataField.ACTION]: '',
        [EImportPersonalDataField.MSISDN]: '',
        [EImportPersonalDataField.SURNAME]: '',
        [EImportPersonalDataField.NAME]: '',
        [EImportPersonalDataField.PATRONYMIC]: '',
        [EImportPersonalDataField.FIO]: '',
        [EImportPersonalDataField.FIO_FROM_FILE]: '',
        [EImportPersonalDataField.NATIONALITY_INFO]: '',
        [EImportPersonalDataField.DOC_TYPE]: '',
        [EImportPersonalDataField.DOC_SERIES]: '',
        [EImportPersonalDataField.DOC_NUMBER]: '',
        [EImportPersonalDataField.DOC_NUMBER_FROM_FILE]: '',
        [EImportPersonalDataField.DOC_ISSUED_BY]: '',
        [EImportPersonalDataField.DOC_DEPARTMENT_CODE]: '',
        [EImportPersonalDataField.DOC_ISSUE_DATE]: '',
        [EImportPersonalDataField.DOC_VALID_DATE]: '',
        [EImportPersonalDataField.BIRTH_DATE]: '',
        [EImportPersonalDataField.BIRTH_PLACE]: '',
        [EImportPersonalDataField.ADDR_COUNTRY]: '',
        [EImportPersonalDataField.ADDR_REGION]: '',
        [EImportPersonalDataField.ADDR_CITY]: '',
        [EImportPersonalDataField.PLANNING_ELEMENT]: {
            title: '',
            description: '',
        },
        [EImportPersonalDataField.ADDR_STREET]: '',
        [EImportPersonalDataField.ADDR_HOUSE]: '',
        [EImportPersonalDataField.ADDR_BLOCK]: '',
        [EImportPersonalDataField.ADDR_STRUCTURE]: '',
        [EImportPersonalDataField.ADDR_APARTMENT]: '',
        [EImportPersonalDataField.EMAIL]: '',
        [EImportPersonalDataField.PIC_STATUS]: '',
        [EImportPersonalDataField.STATUS]: '',
    },
    validateErrors: {},
};
